import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { Message } from 'primeng/primeng';

type Severities = 'success' | 'info' | 'warn' | 'error';

@Injectable({
    providedIn: 'root',
})
export class NotificationsService {
  growlNotificationChange: Subject<Object> = new Subject<Object>();
  messageNotificationChange: Subject<Object> = new Subject<Object>();



  private message: Message[] = [];
 constructor() { 
    console.log('construct notif service'); 

  }
  messageNotifyNow() {
    this.messageNotificationChange.next(this.message);
    this.message = [];
  }

  notificationClear() {
    this.message = [];
    this.messageNotifyNow();
  }

  growlNotify(severity: Severities, summary: string, detail: string) {
    this.growlNotificationChange.next({ severity, summary, detail });
    console.log('growlNotify');
  }
  messageNotify(severity: Severities, summary: string, detail: string) {
    this.messageNotificationChange.next({ severity, summary, detail });
  }

  addNotification(severity: Severities, summary: string, detail: string) {
    this.message.push({ severity, summary, detail });
  }
}